import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { selectOptionById } from '@util/input-utils';
import { parseDec, unsub } from '@util/utils';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html'
})
export class SelectComponent implements OnInit, OnDestroy {

  @Input('label') label = '';

  @Input('readonly') readonly = false;

  selectById = selectOptionById;

  _entries: any[] = [];
  @Input('entries') set entries(entries: any[]) {
    this._entries = entries;
    this.updateSelect();
  }

  _value: any;
  @Input('value') set value(val: any) {
    this._value = val;
    this.updateSelect();
  }

  @Output('change') change = new EventEmitter();

  @Output() idchanges = new EventEmitter();

  selectFC = new UntypedFormControl();

  updateSelect() {
    const v = this._value;
    if (Array.isArray(this._entries) && this._entries.length) {
      for (let i = 0; i < this._entries.length; i++) {
        let e = this._entries[i];
        if (e && e.id == v) {
          this.selectFC.setValue(e);
          break;
        }
      }
    }
  }

  sub!: Subscription;

  ngOnInit() {

    this.sub = this.selectFC.valueChanges.subscribe((entry: any) => {
      if (this.readonly) {
        return;
      }
      if (entry) {
        this._value = entry;
        this.change.emit(entry);

        if (Number.isFinite(entry.id)) {
          this.idchanges.emit(entry.id);
          return;
        }

        if (entry.id && typeof entry.id === 'string') {
          const id = parseDec(entry.id);
          if (!isNaN(id)) {
            this.idchanges.emit(id);
          }
        }
      }
    });
  }

  ngOnDestroy() {
    this.sub = unsub(this.sub);
  }
}
